/**
 * Cloud Infrastructure Cost Tracker - Pricing Constants
 * Hard-coded Firebase/GCP pricing (as of Dec 2025)
 * No external API calls - all calculations done locally
 */

export const PRICING = {
  // Firestore (per operation)
  FS_READ: 0.00000036,        // $0.036 per 100K reads
  FS_WRITE: 0.00000108,       // $0.108 per 100K writes
  FS_DELETE: 0.00000012,      // $0.012 per 100K deletes

  // Cloud Storage (per byte)
  STORAGE_UPLOAD: 5e-11,      // $0.05 per GB upload
  STORAGE_DOWNLOAD: 1.2e-10,  // $0.12 per GB egress

  // Realtime Database (per byte)
  RTDB_DOWNLOAD: 1e-9,        // $1 per GB downloaded

  // Cloud Functions
  FN_INVOCATION: 4e-7,        // $0.40 per 1M invocations
  FN_COMPUTE_100MS: 1e-7,     // Estimated per 100ms (256MB memory)
} as const;

/** Format bytes to human readable string */
export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}

/** Format cost to dollar string */
export function formatCost(cost: number): string {
  if (cost < 0.00001) return '$0.00000';
  if (cost < 0.01) return `$${cost.toFixed(5)}`;
  return `$${cost.toFixed(2)}`;
}

/** Format duration in ms to human readable */
export function formatDuration(ms: number): string {
  if (ms < 1000) return `${Math.round(ms)}ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  return `${(ms / 60000).toFixed(1)}m`;
}
